<template>
  <AppDialog
    icon="fa-solid fa-signs-post"
    :title="selectedVideo ? selectedVideo.title : 'Guide Me'"
    v-model="value"
    :message="message"
    max-width="70vw"
    @cancel="stopAndClose"
    hide-fullscreen
    no-padding
  >
    <template v-slot:toolbar-items>
      <v-menu bottom left offset-y v-if="videos && videos.length > 1">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small text v-bind="attrs" v-on="on">
            <v-icon small left>fa-regular fa-file-video</v-icon>Available Videos
          </v-btn>
        </template>
        <v-list>
          <v-subheader inset>Topic Videos</v-subheader>
          <v-list-item v-for="item in specificVideos" :key="item.video" @click="selectVideo(item)">
            <v-list-item-icon>
              <v-icon>fa-regular fa-file-video</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="moiVideos && moiVideos.length > 0"></v-divider>
          <v-subheader v-if="moiVideos && moiVideos.length > 0" inset>Maybe of Interest</v-subheader>
          <v-list-item v-for="item in moiVideos" :key="item.video" @click="selectVideo(item)">
            <v-list-item-icon>
              <v-icon>fa-regular fa-file-video</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <v-card class="videocard" v-if="value">
      <vimeo-player
        ref="player"
        :video-id="selectedVideo ? selectedVideo.video : ''"
        :options="playerOptions"
        @error="onError"
      >
      </vimeo-player>
    </v-card>
  </AppDialog>
</template>

<script>
import { mapState } from 'vuex'
import AppDialog from './AppDialog'

export default {
  name: 'VideoDialog',
  props: {
    value: {
      type: Boolean,
      description: 'Controls whether the dialog is shown'
    },
    videos: {
      type: Array,
      description: 'Videos available in the dialog',
      default: function () {
        return []
      }
    }
  },
  components: {
    AppDialog
  },
  data() {
    return {
      playerOptions: {
        responsive: true,
        autoplay: false,
        controls: true,
        pip: false
      },
      message: { type: 'error', show: false, text: '' },
      selectedVideo: null
    }
  },
  watch: {
    videos: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal.length < 1) return

        this.selectedVideo = newVal[0]
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!this.selectedVideo && this.videos && this.videos.length === 1) this.selectedVideo = this.videos[0]

        if (newVal && this.videos && this.videos.length === 1 && this.selectedVideo) {
          this.$nextTick(() => {
            this.$refs.player.play()
          })
        }
      }
    }
  },
  computed: {
    ...mapState({
      videoPath: state => state.videoPath
    }),
    specificVideos() {
      return !this.videos || this.videos.length < 1 ? [] : this.videos.filter(x => !x.moi)
    },
    moiVideos() {
      return !this.videos || this.videos.length < 1 ? [] : this.videos.filter(x => x.moi)
    },
    hasPath() {
      return this.videoPath && this.videoPath.url
    },
    combinedPath() {
      let name = this.selectedVideo && this.selectedVideo.video ? this.selectedVideo.video : null
      if (!name) return ''

      if (!this.videoPath || !this.videoPath.url) return name

      let path = this.videoPath.url + (!this.videoPath.url.endsWith('/') ? '/' : '')
      return path + name + '.mp4'
    }
  },
  methods: {
    onError() {
      this.message.text = 'There was an error accessing the video.'
      this.message.show = true
    },
    stopAndClose() {
      this.message.show = false
      this.$refs.player.pause()
      this.$emit('close')
    },
    selectVideo(video) {
      if (!video || !this.$refs.player) return

      // no change
      if (this.selectedVideo && video.video === this.selectVideo.video) return

      this.selectedVideo = video
      this.$refs.player.pause()
      this.$refs.player.source = {
        type: 'video',
        title: this.selectedVideo.title,
        sources: [
          {
            src: this.combinedPath,
            provider: !this.hasPath ? 'vimeo' : 'video/mp4'
          }
        ]
      }

      this.$nextTick(() => {
        this.$refs.player.play()
      })
    }
  }
}
</script>
<style scoped>
.videocard {
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
}

::v-deep .videocard iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  disablepictureinpicture: true;
}
</style>
